/* eslint-disable */

// import axios from 'axios'

const clearState = (context) => {
  context.commit('clearUserState');
}

const parseUser = (context, data) => {
  const user = {
    first_name: data.first_name,
    last_name: data.last_name,
    username: data.username,
    email: data.email,
    should_request_billing_info: data.should_request_billing_info,
    billing_explanation: data.billing_explanation,
    is_staff: data.is_staff,
  }

  context.commit('setUser', user);
}

const updateUser = (context, payload) => {
  context.commit('updateUser', payload);
}

const updateUserShouldRequestBillingInfoFalse = (context) => {
  context.commit('updateUserShouldRequestBillingInfoFalse');
}

export default {
  clearState,
  parseUser,
  updateUser,
  updateUserShouldRequestBillingInfoFalse,
}